import React, {useContext} from 'react';
import _ from 'lodash';
import {showDollarAmountWithDollar} from 'common/utils';
import {Icon, Label} from 'semantic-ui-react';
import {StatusIndicator} from 'app-ui-componentlibrary';
import {MODES} from 'common/requestDetails/constants';
import {Contexts} from 'componentLibrary';
const { RequestDetailsContext} = Contexts;


const InactiveAccordion = ({
  tier,
  isNarrative,
  isValid,
  headerTitle,
  total,
  actualTotal,
  actualAllowedTotal,
  handleToggle,
  sourcePath,
  activityName,
  templatedValue,
  gridLayout,
  editable,
  editLabel,
  ineligible,
  mode,
}) => {
  const rdContext = useContext(RequestDetailsContext);
  let closeoutReviewMode = mode === MODES.CLOSEOUT_REPORT_REVIEW;
  let showActualTotal = false;
  let actualTotalLabel = _.get(rdContext, 'customizations.actualTotalLabel', 'Actual total');
  let actualAllowedTotalLabel = _.get(rdContext, 'customizations.actualAllowedTotalLabel', 'Actual allowed total');
  if (_.isNumber(actualTotal)) {
    showActualTotal = true && !closeoutReviewMode;
  }
  let showActualAllowedTotal = false;
  if (_.isNumber(actualAllowedTotal)) {
    showActualAllowedTotal = true;
  }

  let toDisplayTotalLabel = showActualTotal ? 'Total: ' : '';
  if (mode === MODES.PAYMENT_REQUEST) toDisplayTotalLabel = 'Total requested: ';

  return (
    <div
      id={`item-${_.join(_.split(sourcePath, '.'), '-')}`}
      className={`app_accordion_budget-tier${tier + 1}`}
      aria-label={activityName}
    >
      {!gridLayout ? (
        <div className="accordion-top-content w-clearfix">
          <a
            title={`Open ${headerTitle}`}
            href="#"
            onClick={() => handleToggle()}
            className="accordion-caret w-inline-flex"
          >
            <div className="fa-caret-accordion">
              <Icon name="caret right" />
            </div>
          </a>
          <div className="accordion-clickable-area w-clearfix">
            <a
              href="#"
              onClick={() => handleToggle()}
              className="accordion-clickable-header w-inline-flex w-clearfix"
            >
              <div className="accordion-alert">
                <div className="fa-alert-accordion">
                  {!isValid && editable && (
                    <StatusIndicator
                      status={'needsAttention'}
                      name={activityName}
                      float="left"
                    />
                  )}
                </div>
              </div>
              <h4
                className={`apph4-accordiion-label ${ineligible ? 'strike-through' : ''}`}
              >
                {_.upperFirst(headerTitle)}
              </h4>
              {editLabel || !isNarrative ? (
                <h4 className="apph4-accordiion-label float-right">
                  {editLabel && (
                    <Label className="ui horizontal label">{editLabel}</Label>
                  )}
                  {!isNarrative && !templatedValue && (
                    <span
                      title={mode === MODES.PAYMENT_REQUEST ? 'Total requested' : 'Total'}
                    >
                      {toDisplayTotalLabel}
                      {showDollarAmountWithDollar(total)}
                    </span>
                  )}
                  {!isNarrative && showActualTotal && <span> | </span>}
                  {!isNarrative && showActualTotal && (
                    <span title={actualTotalLabel} className="blue">
                      {actualTotalLabel}: {showDollarAmountWithDollar(actualTotal)}
                    </span>
                  )}
                  {!isNarrative && showActualAllowedTotal && <span> | </span>}
                  {!isNarrative && showActualAllowedTotal && (
                    <span title={actualAllowedTotalLabel} className="blue">
                      {actualAllowedTotalLabel}:{' '}
                      {showDollarAmountWithDollar(actualAllowedTotal)}
                    </span>
                  )}
                </h4>
              ) : null}
            </a>
          </div>
        </div>
      ) : (
        <div className="accordion-top-content w-clearfix">
          <a
            href="#"
            onClick={() => handleToggle()}
            className="accordion-caret w-inline-flex"
            title={`Open ${headerTitle}`}
          >
            <div className="fa-caret-accordion">
              <Icon name="caret right" />
            </div>
          </a>
          <div className="accordion-clickable-area w-clearfix">
            <a
              href="#"
              onClick={() => handleToggle()}
              className="accordion-clickable-header w-inline-flex w-clearfix"
            >
              <div className="accordion-alert">
                <div className="fa-alert-accordion">
                  {!isValid && editable && (
                    <StatusIndicator
                      status={'needsAttention'}
                      name={activityName}
                      float="left"
                    />
                  )}
                </div>
              </div>
              <h4
                className={`apph4-accordiion-label ${ineligible ? 'strike-through' : ''}`}
              >
                {_.upperFirst(headerTitle)}
              </h4>

              <div class="rt-seg_-perc-dollar-amt w-clearfix">
                <h4 class="apph4-accordiion-label float-right">
                  {total.nonFedSharePercent}%
                </h4>
              </div>
              <div class="rt-seg_-perc-dollar-amt w-clearfix">
                <h4 class="apph4-accordiion-label float-right">
                  {editLabel && (
                    <Label className="ui horizontal label">{editLabel}</Label>
                  )}
                  {showDollarAmountWithDollar(total.amount)}
                </h4>
              </div>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};
export default InactiveAccordion;
